/* session.svelte.ts generated by Svelte v5.55.3 */
import * as $ from 'svelte/internal/client';
import { db } from "../db";
import { DEFAULTS } from "../constants";

let activeTimer = $.state(null);
let timerPersistInterval = null;

export function getActiveTimer() {
	return $.get(activeTimer);
}

export async function loadActiveTimer() {
	const saved = await db.activeTimer.get("active");

	if (saved) {
		$.set(activeTimer, saved, true);

		if (timerPersistInterval) clearInterval(timerPersistInterval);

		timerPersistInterval = setInterval(
			async () => {
				if ($.get(activeTimer)) await db.activeTimer.put(toRaw($.get(activeTimer)));
			},
			DEFAULTS.TIMER_PERSIST_INTERVAL_MS
		);
	}
}

function toRaw(obj) {
	return JSON.parse(JSON.stringify(obj));
}

export async function startTimer(childId, type, side) {
	if ($.get(activeTimer)) return false;

	if (timerPersistInterval) {
		clearInterval(timerPersistInterval);
		timerPersistInterval = null;
	}

	$.set(
		activeTimer,
		{
			id: "active",
			childId,
			sessionType: type,
			startTime: Date.now(),
			side,
			switchTimes: []
		},
		true
	);

	await db.activeTimer.put(toRaw($.get(activeTimer)));

	timerPersistInterval = setInterval(
		async () => {
			if ($.get(activeTimer)) await db.activeTimer.put(toRaw($.get(activeTimer)));
		},
		DEFAULTS.TIMER_PERSIST_INTERVAL_MS
	);

	return true;
}

export function switchSide() {
	if (!$.get(activeTimer) || $.get(activeTimer).sessionType !== "nursing") return;

	$.set(
		activeTimer,
		{
			...$.get(activeTimer),
			switchTimes: [...$.get(activeTimer).switchTimes, Date.now()],
			side: $.get(activeTimer).side === "left" ? "right" : "left"
		},
		true
	);
}

export async function stopTimer() {
	if (timerPersistInterval) {
		clearInterval(timerPersistInterval);
		timerPersistInterval = null;
	}

	const stopped = $.get(activeTimer) ? toRaw($.get(activeTimer)) : null;

	$.set(activeTimer, null);
	await db.activeTimer.delete("active");

	return stopped;
}

export function getElapsedMs() {
	if (!$.get(activeTimer)) return 0;

	return Date.now() - $.get(activeTimer).startTime;
}